var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _path19, _path20, _path21, _path22, _circle2, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 713.11 237.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 573.51,
    y1: 12.74,
    x2: 573.51,
    y2: 49.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#cacccd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b7b8b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#989899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6b6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#363334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 403.2,
    y1: 3.09,
    x2: 403.2,
    y2: 80.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 685.59,
    y1: 164.93,
    x2: 685.59,
    y2: 155.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8c8d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5a5b5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#333434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#171718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 687.24,
    y1: 169.71,
    x2: 687.24,
    y2: 160.15,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 275.67,
    y1: 17.29,
    x2: 275.67,
    y2: 69.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 489.84,
    y1: 5.45,
    x2: 521.95,
    y2: 5.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#c9cbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#eceeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 672.84,
    y1: 65.8,
    x2: 688.1,
    y2: 65.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e1e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#edeeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 356.55,
    y1: 195.54,
    x2: 356.55,
    y2: 27.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c6c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#d9dbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e7e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eff0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 266.7,
    y1: 111.02,
    x2: 266.7,
    y2: 68.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d9dbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 165.87,
    y1: 93.06,
    x2: 165.87,
    y2: 71.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 26.72,
    y1: 154.99,
    x2: 95.71,
    y2: 154.99,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 194.55,
    y1: 167.79,
    x2: 488.15,
    y2: 167.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 474.9,
    y1: 183.96,
    x2: 370.87,
    y2: 3.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#dedfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 216.36,
    y1: 138.04,
    x2: 704.01,
    y2: 138.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 316.14,
    y1: 137.62,
    x2: 495.87,
    y2: -42.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 185.11,
    y1: 183.66,
    x2: 493.24,
    y2: 183.66,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 266.2,
    y1: 59.75,
    x2: 296.59,
    y2: 59.75,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 37.12,
    y1: 122.1,
    x2: 72.55,
    y2: 122.1,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 46.26,
    y1: 130.45,
    x2: 46.26,
    y2: 122.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 49.38,
    y1: 129.78,
    x2: 49.38,
    y2: 119.56,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 552.19,
    y1: 69.21,
    x2: 681.49,
    y2: 69.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 136.6,
    y1: 147.93,
    x2: 129.17,
    y2: 147.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a3a5a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#79797b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#5a5a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#484749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 128.11,
    y1: 147.25,
    x2: 135.72,
    y2: 147.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 144.46,
    y1: 149.69,
    x2: 132.88,
    y2: 149.69,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -577.27,
    y1: 1302.7,
    x2: -584.69,
    y2: 1302.7,
    gradientTransform: "rotate(-72 -1025.03956213 259.79011577)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -585.75,
    y1: 1302.02,
    x2: -578.14,
    y2: 1302.02,
    gradientTransform: "rotate(-72 -1025.03956213 259.79011577)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -569.41,
    y1: 1304.46,
    x2: -580.98,
    y2: 1304.46,
    gradientTransform: "rotate(-72 -1025.03956213 259.79011577)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -1895.3,
    y1: 981.21,
    x2: -1902.72,
    y2: 981.21,
    gradientTransform: "rotate(-144 -1024.6877128 260.15030663)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -1903.78,
    y1: 980.53,
    x2: -1896.17,
    y2: 980.53,
    gradientTransform: "rotate(-144 -1024.6877128 260.15030663)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -1887.44,
    y1: 982.97,
    x2: -1899.01,
    y2: 982.97,
    gradientTransform: "rotate(-144 -1024.6877128 260.15030663)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -1997.4,
    y1: -372.14,
    x2: -2004.83,
    y2: -372.14,
    gradientTransform: "rotate(144 -1024.85315498 260.31067215)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -2005.89,
    y1: -372.83,
    x2: -1998.28,
    y2: -372.83,
    gradientTransform: "rotate(144 -1024.85315498 260.31067215)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -1989.54,
    y1: -370.39,
    x2: -2001.12,
    y2: -370.39,
    gradientTransform: "rotate(144 -1024.85315498 260.31067215)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -741.39,
    y1: -887.83,
    x2: -748.81,
    y2: -887.83,
    gradientTransform: "rotate(72 -1025.20469224 259.95197487)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -749.87,
    y1: -888.51,
    x2: -742.26,
    y2: -888.51,
    gradientTransform: "rotate(72 -1025.20469224 259.95197487)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -733.53,
    y1: -886.07,
    x2: -745.1,
    y2: -886.07,
    gradientTransform: "rotate(72 -1025.20469224 259.95197487)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 110.58,
    y1: 173.64,
    x2: 142.67,
    y2: 173.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d1d2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#cdcecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8c8d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 569.34,
    y1: 147.22,
    x2: 561.92,
    y2: 147.22,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 560.86,
    y1: 146.54,
    x2: 568.47,
    y2: 146.54,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 577.2,
    y1: 148.98,
    x2: 565.63,
    y2: 148.98,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -442.88,
    y1: 1714.04,
    x2: -450.3,
    y2: 1714.04,
    gradientTransform: "rotate(-72 -1025.03956213 259.79011577)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -451.36,
    y1: 1713.36,
    x2: -443.76,
    y2: 1713.36,
    gradientTransform: "rotate(-72 -1025.03956213 259.79011577)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -435.02,
    y1: 1715.79,
    x2: -446.59,
    y2: 1715.79,
    gradientTransform: "rotate(-72 -1025.03956213 259.79011577)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -2244.97,
    y1: 1236.16,
    x2: -2252.4,
    y2: 1236.16,
    gradientTransform: "rotate(-144 -1024.6877128 260.15030663)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -2253.45,
    y1: 1235.48,
    x2: -2245.85,
    y2: 1235.48,
    gradientTransform: "rotate(-144 -1024.6877128 260.15030663)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -2237.11,
    y1: 1237.92,
    x2: -2248.68,
    y2: 1237.92,
    gradientTransform: "rotate(-144 -1024.6877128 260.15030663)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -2347.92,
    y1: -625.94,
    x2: -2355.34,
    y2: -625.94,
    gradientTransform: "rotate(144 -1024.85315498 260.31067215)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -2356.4,
    y1: -626.62,
    x2: -2348.79,
    y2: -626.62,
    gradientTransform: "rotate(144 -1024.85315498 260.31067215)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -2340.06,
    y1: -624.18,
    x2: -2351.63,
    y2: -624.18,
    gradientTransform: "rotate(144 -1024.85315498 260.31067215)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -608.36,
    y1: -1299.6,
    x2: -615.78,
    y2: -1299.6,
    gradientTransform: "rotate(72 -1025.20469224 259.95197487)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -616.84,
    y1: -1300.28,
    x2: -609.23,
    y2: -1300.28,
    gradientTransform: "rotate(72 -1025.20469224 259.95197487)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -600.49,
    y1: -1297.85,
    x2: -612.07,
    y2: -1297.85,
    gradientTransform: "rotate(72 -1025.20469224 259.95197487)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 543.33,
    y1: 172.93,
    x2: 575.42,
    y2: 172.93,
    gradientTransform: "rotate(76.81 559.37460694 172.92602547)",
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 55.69,
    y1: 115.11,
    x2: 72.89,
    y2: 115.11,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 344.04,
    y1: 92.19,
    x2: 373.07,
    y2: 92.19,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 371.45,
    y1: 93.82,
    x2: 372.27,
    y2: 93.82,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 365.3,
    y1: 94.62,
    x2: 371.45,
    y2: 94.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5f5e60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8b8b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b0b0b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cccdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e1e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#edeeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 372.49,
    y1: 93.15,
    x2: 372.76,
    y2: 93.15,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 344.15,
    y1: 94.97,
    x2: 351.44,
    y2: 94.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#edeeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e1e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cccdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#b0b0b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#8b8b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5f5e60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 486.53,
    y1: 86.83,
    x2: 515.56,
    y2: 86.83,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 513.94,
    y1: 88.46,
    x2: 514.77,
    y2: 88.46,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 507.79,
    y1: 89.27,
    x2: 513.94,
    y2: 89.27,
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 514.98,
    y1: 87.79,
    x2: 515.25,
    y2: 87.79,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 486.65,
    y1: 89.62,
    x2: 493.93,
    y2: 89.62,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 204.32,
    cy: -2890.54,
    r: 113.38,
    gradientTransform: "matrix(3.14 0 0 .12 -285.98 569.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#454446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#505052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#636366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7d7e81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#999b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#bfc0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#dadcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ebecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 173.7,
    cy: 127.17,
    r: 79.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d1d2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 126.63,
    cy: 173.64,
    r: 54.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 126.63,
    cy: 173.64,
    r: 33.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 126.63,
    cy: 173.64,
    r: 5.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#d1d2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 126.63,
    cy: 173.64,
    r: 39.1,
    gradientTransform: "rotate(45 126.6258903 173.6401611)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 126.02,
    cy: 162.86,
    r: 2.17,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 141.83,
    cy: 313.37,
    r: 2.17,
    gradientTransform: "rotate(-72 30.96438305 259.7909359)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 4.44,
    cy: 375.4,
    r: 2.17,
    gradientTransform: "rotate(-144 31.31111493 260.15000958)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -97.67,
    cy: 263.53,
    r: 2.17,
    gradientTransform: "rotate(144 31.14567274 260.3109692)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -22.28,
    cy: 131.36,
    r: 2.17,
    gradientTransform: "rotate(72 30.79925295 259.95115473)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 559.38,
    cy: 172.93,
    r: 54.08,
    gradientTransform: "rotate(77.02 559.39637482 172.94926868)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 559.38,
    cy: 172.93,
    r: 33.87,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 559.38,
    cy: 172.93,
    r: 5.23,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 559.38,
    cy: 172.93,
    r: 39.1,
    gradientTransform: "rotate(76.93 559.3858541 172.94460738)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 558.76,
    cy: 162.15,
    r: 2.17,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 276.22,
    cy: 724.71,
    r: 2.17,
    gradientTransform: "rotate(-72 30.96438305 259.7909359)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: -345.24,
    cy: 630.34,
    r: 2.17,
    gradientTransform: "rotate(-144 31.31111493 260.15000958)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -448.18,
    cy: 9.73,
    r: 2.17,
    gradientTransform: "rotate(144 31.14567274 260.3109692)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 110.75,
    cy: -280.42,
    r: 2.17,
    gradientTransform: "rotate(72 30.79925295 259.95115473)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 212.66,
    cy: 117.57,
    r: 2.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#272324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#322f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#464344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#615f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#848383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e1e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 360.56,
    cy: 85.45,
    r: 13.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9d9fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d9dbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 503.05,
    cy: 80.09,
    r: 13.99,
    xlinkHref: "#radial-gradient-22"
  }), /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:#fe8595}.cls-5{fill:#1c0101}.cls-11{fill:#171916}.cls-12{fill:#2d2d31}.cls-25{fill:#7b7f79}.cls-32,.cls-39{fill:none;stroke-miterlimit:10}.cls-32{stroke:#2d2d31;stroke-width:.36px}.cls-39{stroke:#141414;stroke-width:2.96px}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m686.39 96.27-12-.24-15.13-8.2-.55-.3-7.6-6.84-.59-2.69-.19-.87v-.12l-.37-1.62c1.07.16 3.69-7.74 18-9.1a84.73 84.73 0 0 1 14.83-.46 12.39 12.39 0 0 1 2.61.42h.09s.14 5.7.77 7.13 4.14 9.16.13 22.89Z",
    style: {
      fill: "#fc1f39"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.2 77.1s13.33-1.15 20 0 7.53.89 7.53.89l-2-4.14-2.68-1.76-1.91-4.22L663.88 71l-5 3.79Z",
    style: {
      fill: "#f36e7c"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m651.08 76.77 9.28.33s-.09 2.18 3.43 5.21 5.17 7.09 9.9 8.61 9.31 2 11.63-.18l-1.92 3.39-8.24-.32-6.52-2.09-8.59-6.51-8.24-7.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M660.36 77.1a4.32 4.32 0 0 1 2.77-4.86c3.47-1.29 16.5-3.7 17.34-3.07s.7 3.4 3.09 4.33-1.14-6.65-1.14-6.65l-1.95-1.18-13.1 1.89-10.93 3.17-1.44 2.18-3.93 3.57.59.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m686.39 96.27-12-.24-15.13-8.2-8.74-9.83-.59-.66.37-.33 1.06-1s1.07 2.56 5.65 6.06 9.57 8.68 14.26 10.46 10.16 2 12.77-.3 2.85-9 2.35-12.36-1.16-5.7-3.06-6.47-1.84-4.1-1.84-4.1l-.24-3.49h1.46a12.39 12.39 0 0 1 2.61.42h.09s.14 5.7.77 7.13 4.22 9.18.21 22.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M532.27 12.74s72.85 27.57 88.9 36.59l-7.84.58s-61.45-26.74-62.52-27-25-9.62-25-9.62Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 356.55,
    cy: 224.01,
    rx: 356.55,
    ry: 13.55,
    style: {
      mixBlendMode: "multiply",
      fill: "url(#radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 80.81c1.9 0 65.37-49.44 65.37-49.44L349.6 9.5l82.72-6.41L487 6.65l67.27 20.89 22.1 20.71-20.91 28Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.73 164.93h21.91a1.59 1.59 0 0 0 1.59-1.39c.24-1.88.48-5.24-.46-7.31a1.51 1.51 0 0 0-1.38-.86h-11Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.38 169.71h21.91a1.6 1.6 0 0 0 1.59-1.39c.23-1.88.48-5.24-.46-7.31a1.51 1.51 0 0 0-1.38-.86h-11Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m185.11 196.26 299.02-7.32 18.64-.13-1.76-7.25-314.98 11.41-.92 3.29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M500.72 186.67s7.57 8.39 12.43 10.11 95.78-20.43 95.78-20.43l16.58 1.49-18.36-69.4-39.94-11.11-44.21 4.82-29.76 43.5ZM61.22 195.54s6.28 4 9.31 4.16 5.17-2.22 9.63-4.16 82.72 7 87.35 8.76 22.65-11.58 22.65-11.58-4.77-57.53-18.88-69.33S116.91 105 116.91 105l-33.36 13.18-22.88 23.37 4.51 29.23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m685.32 66.22-2.5 1a62.21 62.21 0 0 0-15.59 1.47c-7 1.83-5.67 1.12-8.92 3a35.76 35.76 0 0 0-6.37 4.53 6.81 6.81 0 0 1-1.61.82l-.4-1.74c1.07.16 3.69-7.74 18-9.1 12.88-1.2 16.77-.2 17.39.02Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M247.47 78.26S290.7 47.18 297.84 42s32.62-19 50.09-23.24 51-5.52 51-5.52 60.43-.89 80.4 1.78 50.1 11 64 19.43 7.49 20.5 7.49 20.5l-4.46 9.81 13.55-.89s11-17.59 7-24.43-29.06-19.61-38.69-22.1-62.93-13.91-80.94-13-63 .3-78.5 4.4-36.61 5.59-43.38 9.51-17.59 10.46-17.59 10.46l-65.1 40.88-9.45 9.9s-1.25 3.3 0 3.3S263.7 80 263.7 80l-5.35-2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m400.2 10.9-19.23 60.56 13.78-.81 13.56-59.75h-8.11zM418.29 10.9l-8.32 60.41-13.8-.75 14.28-59.66h7.84zM501.96 17.29l-5.88 48.57 4.82-.21 5-47.11-3.94-1.25z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313 17.29s-53.85 28.42-85.34 52.39l15.45-.16s22.82-15.68 23.6-16.28 57-34.47 57-34.47Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.84 4.33a37.05 37.05 0 0 1 12-4 51.78 51.78 0 0 1 14.8.48s1 5.11 3.63 8.2 1.36 1.42 1.36 1.42Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.84 56.25s11.37.09 12.62 0c0 0 2.45 2.31 2.62 4.67s-1.22 13.55-1.08 14.44a13.59 13.59 0 0 0-2.62-2.23 3.87 3.87 0 0 1-1.93-3 17.86 17.86 0 0 0-.91-4.61c-1.24-3.31-8.7-9.27-8.7-9.27Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.39 96.27s-3.53 7.6-7.58 10.89-18.89 5.86-35.65 8a107.37 107.37 0 0 1-60.62-10.51c-22.1-10.87-62.75 2.51-62.75 2.51s-120-3.29-167.82-2.34-106.13 6.19-115.4 7.73-20.21 11.53-20.21 11.53 18.9 31.73 88.07 27.81S426 148 449.55 148a22.18 22.18 0 0 0 2.77-.18 279.22 279.22 0 0 1 51.38 8.66c-1.6 8.09-2.12 17.83-1.76 30.74l-8.72.2-307.16 7.38s0-6.83-.95-16.17c-1.54-14.66-5.54-35.54-16-46-17.12-17.11-39-27.81-69.89-13-1.58.76-3.08 1.58-4.52 2.45-.57.42-1.37 1-2.26 1.61A51.88 51.88 0 0 0 73.76 147c-5.69 13.78-6.35 29.53-4.76 42.73.23 1.8.5 3.63.82 5.52.13.72-11.3.18-21.89-.8h-.27c-7.29-.68-14.14-1.55-16.43-2.35 0 0 .93-4.32 0-4.9s-3.48-.89-4-3.56-.59-13.27-.36-22.78v-.32c.07-2.38.14-4.59.21-6.57.23-5.79.53-9.66.85-10.31.24-.47 1.95-1.55 4.11-2.67l-.36-5.17 6.24-15.71a3 3 0 0 1-.67.24c-.36-.13-7.56.58-7.56.58a8.69 8.69 0 0 1 1-2.69c.42-.85 2.58-2.59 4.91-4.32l.3-.22c3-2.23 6.3-4.36 6.3-4.36a214.42 214.42 0 0 1 66-25.26c37.91-7.49 111.48-14 111.48-14s9.63-.3 12.9-.65 11.76-3.51 11.76-3.51l4.28 3.68-14.31 11.45 74.94-5.34L422.81 69l129.43-5.53s2.94.8 4.5-.67 7.93-13.77 8-16.62-.09-6.28-4.1-9.45l4.9-9.18S613.65 49.29 620 49.29s52.86 7 52.86 7l5.53 4.09a6.85 6.85 0 0 1 1.24 1.16l.1.11a7.64 7.64 0 0 1 1.42 2.69l.36 1.22S664.55 67.3 658.13 70c-.5.2-1 .41-1.39.62-5.15 2.46-5.84 4.83-6.09 6.15s13.46 12.39 16.22 14a27.56 27.56 0 0 0 9.53 3.66c4.47.85 9.99 1.84 9.99 1.84Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1 118.18a60.37 60.37 0 0 1-9.42 2.69L28 130.94l8.77-1.1Z",
    style: {
      fill: "#26251b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 130.94 7.77-1 1.9 4.86 17.34-6-7.89 9.29-19.78 10.34a16.36 16.36 0 0 1-.8-6.57c.36-3.48 1.46-10.92 1.46-10.92Z",
    style: {
      fill: "#8c918d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.23 192s.93-4.32 0-4.9-3.48-.89-4-3.56-.59-13.27-.36-22.78v-.32l11.62 1.4s-.73 15.05-.27 16.35 5.7.78 5.7.78l3.75 15.38c-7.3-.64-14.15-1.51-16.44-2.35Z",
    style: {
      fill: "#554c39"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M39.1 118.18a5.41 5.41 0 0 0-3 4.33c-.4 3.95-.73 10.81 1.48 12.68 3.15 2.67 15-4.87 15-4.87l25.61-15.87s-15.51-3.86-18.54-3.39a123.15 123.15 0 0 0-20.55 7.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.67 111S80 99.47 127.82 93.89 375 74.4 375 74.4l97.73-5.4S165.73 91.63 137 95.2s-40.2 5.08-76.33 15.8Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.68 93.06s8.29-6.6 35.12-9.63 108.45-9.68 115.25-12.12c0 0-5.08 6.15-7.31 6.59s-39.93 1.16-65.16 4.28-51.7 5.35-77.9 10.88Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.85 178.63h-9.74c-1.54-14.66-5.54-35.54-16-46-17.12-17.11-39-27.81-69.89-13-1.58.76-3.08 1.58-4.52 2.45-.57.42-1.37 1-2.26 1.61l-5-3.4s21-15.34 44.21-12.84 37.68 12.48 43.74 20.32 18.75 26.14 19.46 50.86Z",
    style: {
      fill: "url(#radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.85 128.13c-4 3.75-24.64 22.69-17 67.08.13.72-11.3.18-21.89-.8h-.27c-7.29-.68-14.14-1.55-16.43-2.35 0 0 .93-4.32 0-4.9s-3.48-.89-4-3.56-.59-13.27-.36-22.78v-.32c.07-2.38.14-4.59.21-6.57.23-5.79.53-9.66.85-10.31.45-.9 6.24-4 10.34-5.32s9-2.62 12.43-6.36S78 114.45 78.14 114.45 88 117.18 90 118.19s5.06 2.68 5.65 2.91-4.84 3.29-8.8 7.03Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.44 162.29s-.83 14.2-.38 15.51.71 1.78 2 1.9a14.92 14.92 0 0 0 3.89-.68s-4.53-16.77-4.58-16.9-.84-.23-.93.17Z",
    style: {
      fill: "#030404"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.51 162-12.65-1.52c.07-2.38.14-4.59.21-6.57.32 0 7.61.4 9.47 2.31s2.97 5.78 2.97 5.78ZM31.23 192s.93-4.32 0-4.9a17.6 17.6 0 0 1-.77-3 23.31 23.31 0 0 1-.26-3.1s12.45-.45 13.71-.67c1-.17 3 9.35 4 14.13-7.37-.73-14.36-1.61-16.68-2.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.55 173.76s240-8.85 291.79-16.25a1.59 1.59 0 0 1 1.65 2.27l-1.31 2.68a1.56 1.56 0 0 1-1.33.89c-17 1-265 15.6-290.5 14.69Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.76 107.16 346 93.06C357.68 92 619.74 73.14 650.65 76.74a27.74 27.74 0 0 0 3.35 3.81S404.38 93.18 341.93 97.93s-150.17 9.23-150.17 9.23Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 136c.12.83-9.86 30.07-10.7 30.31s-72.38 13.79-73.09 13.55 2.38-41.48-26.27-60.26-63-8.55-75.71 7.37c-7.54 9.45-12.18 17.73-14.52 29.52a279.22 279.22 0 0 0-51.38-8.66 22.18 22.18 0 0 1-2.77.18c-23.53 0-75.95 0-145.12 3.92s-88.07-27.81-88.07-27.81 10.93-10 20.21-11.53 67.63-6.78 115.4-7.73 167.82 2.34 167.82 2.34 40.65-13.38 62.75-2.51a107.37 107.37 0 0 0 60.62 10.51c16.76-2.14 31.61-4.7 35.65-8s7.58-10.89 7.58-10.89a21 21 0 0 0 6.92 15.33c7.25 6.29 9 7.36 9.39 12.48a36.79 36.79 0 0 1-.83 10s2.01 1.01 2.12 1.88Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.35 65.84 76.13-47.13-7.48-1.42s15-6.95 39.34-10 100.25-8.5 130.2-4.4 49.74 9.89 49.74 9.89l-4.64.89s34 11.58 37.89 13.91l-4.9 9.18s-12.3-12.66-64.09-25-146.58 0-158 4.13-36.84 12.75-89.91 53.63Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.06 194.8s0-6.83-.95-16.17c0 0 247.68-9.39 269.07-4.87 18.76 4 30.39 7.91 39.06 13.63Z",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M250.35 79.09s20.21-1.43 29.18-3.86 17.65-1.9 18.31-5.71a8.37 8.37 0 0 0-1.25-6.24s-21.93 1.25-22.11 1.25-4.63 3.39-4.63 3.39l-11 1.07-14.08 8.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.2 68.27c.35-1.12 1.45-9.21 3.76-11.64s10.34-7 16.94-4.87 6.89 3.09 6.89 3.09 2.8 6.18 2.8 8.43c0 0-20.33.78-22.7 2s-2.22 2.44-2.22 2.44Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m259.23 78.32 124.89-9.33 115.35-5.71 51.34-1.78-2.13 2.11-61.34 2.62-90.67 4.3-67.86 4.02-60.93 4.11-8.65.62v-.96z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M396.17 70.56s-18.61 22.35-7.93 98.37M236.26 80.22s-29.38 17.61-10.48 97"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m185.11 179.07 213.21-10.14 104.45-6.45"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M487.61 163.41s27.43-49.55 38.84-61.68 19-34.26 22.6-38.48M599 123.39s57-3.53 63.74-10.16 10.07-19.74 10.07-19.74"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.09 121.22a60.28 60.28 0 0 1 13.31-6.41c1.92-.66 3.43-1.16 4.62-1.55a16.25 16.25 0 0 1 8.33-.48l8.2 1.67s-10.1-2-16.58.42-16.93 5.7-17.41 9.44 2.79 7.43 2.79 7.43-6.68-6.39-3.26-10.52Z",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m407.81 13.1-12.56 55.34 1.44-.07 13.23-55.27h-2.11z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.22 123.9v6.55s2.09-.49 2.09-3.28v-4a1 1 0 0 0-1.36-1c-.4.2-.73.66-.73 1.73Z",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.65 121.72v8.06s1.47-.6 1.47-4v-4.88c0-.87-.49-1.55-.95-1.23-.29.17-.52.73-.52 2.05Z",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m41.19 117.39-.2.3-5.4-3.83.3-.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M681.49 65.52S664.55 67.3 658.13 70c-.5.2-1 .41-1.39.62a596.14 596.14 0 0 1-69.2 5.69s-27.82 1.42-33.4 0 2.6-13.49 2.6-13.49l122.87-1.32.1.11a7.64 7.64 0 0 1 1.42 2.69Z",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.63,
    cy: 173.64,
    r: 54.08,
    style: {
      fill: "url(#radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.63,
    cy: 173.64,
    r: 33.87,
    style: {
      fill: "url(#radial-gradient-4)"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 126.63,
    cy: 173.64,
    r: 35.12,
    transform: "rotate(-80.88 126.64081404 173.6430005)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.6 137.29s-4.38 13.53-4.68 16.44.06 4 .36 4.28 3.44-3.69 3.44-3.69-1.13 4.82-3.5 5.17-2.8.42-3-2.91 3.44-14.79 3.44-14.79l2.27-5.58Z",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.12 159.14a82.17 82.17 0 0 1 3.74-23.77l3.86 1.07s-7.43 18.89-6.12 22.34Z",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.72 154.32 5.05-14.85 3.69 1.6s-6.9 16.76-10.4 18.84l-1.18-.64a27.77 27.77 0 0 0 2.84-4.95Z",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.15 152.93s11.5 8.34 14.18 9.53 3.81 1.17 4.18 1-2.44-4.42-2.44-4.42 4.23 2.56 3.83 4.93-.46 2.79-3.7 2-13-7.85-13-7.85l-4.6-3.89Z",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.3 167.74a82 82 0 0 1-21.45-10.9l2.21-3.35s15.68 12.91 19.36 12.73Z",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.07 159-12.57-9.37 2.67-3s13.81 11.73 14.7 15.71l-1 .92a27.38 27.38 0 0 0-3.8-4.26Z",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.21 197.18s11.49-8.36 13.44-10.55 2.29-3.25 2.23-3.67-5 1-5 1 3.74-3.23 5.88-2.12 2.5 1.3.74 4.13-11.49 9.95-11.49 9.95l-5.11 3.17Z",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.91 184.49a82.25 82.25 0 0 1-17 17l-2.49-3.14s17.12-10.92 18.08-14.48Z",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92 183.92 95.1 193l-2-3.47s15.42-9.5 19.48-9.12l.57 1.21a27.45 27.45 0 0 0-5.23 2.3Z",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.93 208.9s-4.41-13.52-5.88-16.05-2.39-3.18-2.8-3.25-.62 5-.62 5-1.92-4.56-.21-6.25 2-2 4.17.58 5.91 14 5.91 14l1.44 5.85Z",
    style: {
      fill: "url(#linear-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 186.24a82.14 82.14 0 0 1 10.94 21.43l-3.75 1.41S136 189.42 133 187.4Z",
    style: {
      fill: "url(#linear-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.63 194.61 4.64 15-3.92.87s-4.28-17.61-2.66-21.35l1.33-.17a27.57 27.57 0 0 0 .61 5.65Z",
    style: {
      fill: "url(#linear-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27 171.88s-14.21 0-17.07.64-3.77 1.28-4 1.66 4.57 2.14 4.57 2.14-4.93.41-6-1.74-1.26-2.53 1.83-3.78 15.14-1.3 15.14-1.3l6 .44Z",
    style: {
      fill: "url(#linear-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88 170.57a82.36 82.36 0 0 1 23.76-3.79l.18 4s-20.27-1.23-23.14 1.08Z",
    style: {
      fill: "url(#linear-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.81 176.32 15.69.21-.39 4S145 179.15 142 176.46l.25-1.31a28 28 0 0 0 5.56 1.17Z",
    style: {
      fill: "url(#linear-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.63,
    cy: 173.64,
    r: 16.04,
    style: {
      fill: "url(#linear-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.63,
    cy: 173.64,
    r: 5.23,
    style: {
      fill: "url(#radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.63,
    cy: 173.64,
    r: 37.68,
    transform: "rotate(-45 126.63279208 173.63698008)",
    style: {
      stroke: "url(#radial-gradient-6)",
      strokeWidth: "2.85px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.34 162.34a2.39 2.39 0 0 0-1.82-.83 2.42 2.42 0 0 0-2.42 2.42 2.37 2.37 0 0 0 .18.93 2.37 2.37 0 0 1-.59-1.58 2.42 2.42 0 0 1 4.65-.94Z",
    style: {
      fill: "url(#radial-gradient-7)"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.53 163.28a2.42 2.42 0 0 1-4.25 1.58 2.37 2.37 0 0 1-.18-.93 2.42 2.42 0 0 1 2.42-2.42 2.39 2.39 0 0 1 1.82.83 2.43 2.43 0 0 1 .19.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.41 168.52a2.4 2.4 0 0 0-1.35 1.47 2.43 2.43 0 0 0 1.55 3.06 2.41 2.41 0 0 0 1 .11 2.42 2.42 0 1 1-1.15-4.64Z",
    style: {
      fill: "url(#radial-gradient-8)"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M117.37 168.63a1.66 1.66 0 1 1-1-.11 2.26 2.26 0 0 1 1 .11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.6 181.77A2.42 2.42 0 0 0 123 183a2.32 2.32 0 0 0 .4-.86 2.35 2.35 0 0 1-.45 1.62 2.42 2.42 0 0 1-4.32-2Z",
    style: {
      fill: "url(#radial-gradient-9)"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M119 180.9a2.43 2.43 0 0 1 3.38-.54 2.39 2.39 0 0 1 1 1.76 2.32 2.32 0 0 1-.4.86 2.42 2.42 0 0 1-4.37-1.21 2.64 2.64 0 0 1 .39-.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.89 183.78a2.4 2.4 0 0 0 2-.39 2.44 2.44 0 0 0 .54-3.39 2.69 2.69 0 0 0-.7-.65 2.39 2.39 0 0 1 1.4.94 2.41 2.41 0 0 1-3.2 3.49Z",
    style: {
      fill: "url(#radial-gradient-10)"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M131.18 183.14a2.43 2.43 0 0 1 2.51-3.79 2.69 2.69 0 0 1 .7.65 2.44 2.44 0 0 1-.54 3.39 1.67 1.67 0 0 1-2.67-.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.9 171.77a2.35 2.35 0 0 0 .23-2 2.43 2.43 0 0 0-3.88-1.1 2.42 2.42 0 1 1 3.65 3.08Z",
    style: {
      fill: "url(#radial-gradient-11)"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M137.07 172.25a2.43 2.43 0 0 1-3-1.56 2.11 2.11 0 1 1 4.11-.9 1.67 1.67 0 0 1-1.06 2.46Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 559.38,
    cy: 172.93,
    r: 54.08,
    transform: "rotate(-77.02 559.40651391 172.91595867)",
    style: {
      fill: "url(#radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.38,
    cy: 172.93,
    r: 33.87,
    style: {
      fill: "url(#radial-gradient-13)"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 559.38,
    cy: 172.93,
    r: 35.12,
    transform: "rotate(-76.92 559.3605321 172.9275165)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M569.34 136.58S565 150.11 564.66 153s.06 4 .36 4.28 3.45-3.69 3.45-3.69-1.13 4.82-3.51 5.17-2.79.42-3-2.91 3.45-14.8 3.45-14.8l2.27-5.57Z",
    style: {
      fill: "url(#linear-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.86 158.43a82.17 82.17 0 0 1 3.74-23.77l3.87 1.07s-7.43 18.89-6.12 22.34Z",
    style: {
      fill: "url(#linear-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.47 153.61 5-14.85 3.68 1.6s-6.89 16.76-10.4 18.84l-1.17-.65a27.56 27.56 0 0 0 2.89-4.94Z",
    style: {
      fill: "url(#linear-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.89 152.22s11.51 8.34 14.19 9.52 3.8 1.18 4.18 1-2.44-4.42-2.44-4.42 4.23 2.56 3.83 4.93-.47 2.79-3.71 2-13-7.86-13-7.86l-4.6-3.88Z",
    style: {
      fill: "url(#linear-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 167a82 82 0 0 1-21.45-10.9l2.22-3.35s15.67 12.91 19.35 12.73Z",
    style: {
      fill: "url(#linear-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.82 158.31-12.57-9.39 2.66-3s13.81 11.73 14.71 15.71l-1 .92a27.38 27.38 0 0 0-3.8-4.24Z",
    style: {
      fill: "url(#linear-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 196.47s11.49-8.37 13.45-10.55 2.29-3.25 2.22-3.67-5 1-5 1 3.74-3.23 5.87-2.13 2.51 1.31.74 4.14-11.48 9.95-11.48 9.95l-5.12 3.17Z",
    style: {
      fill: "url(#linear-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.65 183.78a82.17 82.17 0 0 1-17 17l-2.5-3.13s17.12-10.92 18.09-14.48Z",
    style: {
      fill: "url(#linear-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.67 183.21-12.82 9-2-3.47s15.43-9.5 19.49-9.12l.57 1.21a27.45 27.45 0 0 0-5.24 2.38Z",
    style: {
      fill: "url(#linear-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.67 208.19s-4.4-13.52-5.87-16.05-2.39-3.19-2.81-3.25-.62 5-.62 5-1.91-4.55-.2-6.24 2-2 4.16.58 5.91 14 5.91 14l1.44 5.85Z",
    style: {
      fill: "url(#linear-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.7 185.53A82.14 82.14 0 0 1 577.64 207l-3.75 1.41s-5.1-19.66-8.19-21.68Z",
    style: {
      fill: "url(#linear-gradient-48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.37 193.89 4.65 15-3.93.87s-4.27-17.61-2.66-21.35l1.33-.17a27.44 27.44 0 0 0 .61 5.65Z",
    style: {
      fill: "url(#linear-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 171.17s-14.22 0-17.08.63-3.77 1.29-4 1.67 4.57 2.13 4.57 2.13-4.92.42-6-1.73-1.26-2.53 1.84-3.78 15.13-1.3 15.13-1.3l6 .44Z",
    style: {
      fill: "url(#linear-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.62 169.86a82.38 82.38 0 0 1 23.77-3.79l.17 4s-20.26-1.23-23.14 1.08Z",
    style: {
      fill: "url(#linear-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.55 175.6 15.69.22-.38 4s-18.07-1.38-21.13-4.07l.25-1.32a27.09 27.09 0 0 0 5.57 1.17Z",
    style: {
      fill: "url(#linear-gradient-52)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.38,
    cy: 172.93,
    r: 16.04,
    transform: "rotate(-76.81 559.3703447 172.92466076)",
    style: {
      fill: "url(#linear-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.6 172.93a5.23 5.23 0 1 1-5.22-5.23 5.23 5.23 0 0 1 5.22 5.23Z",
    style: {
      fill: "url(#radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.38,
    cy: 172.93,
    r: 37.68,
    transform: "rotate(-76.93 559.39434484 172.92180274)",
    style: {
      stroke: "url(#radial-gradient-15)",
      strokeWidth: "2.85px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.09 161.63a2.42 2.42 0 0 0-4.25 1.59 2.38 2.38 0 0 0 .19.93 2.37 2.37 0 0 1-.59-1.58 2.42 2.42 0 0 1 4.65-.94Z",
    style: {
      fill: "url(#radial-gradient-16)"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M561.28 162.57a2.42 2.42 0 0 1-4.25 1.58 2.38 2.38 0 0 1-.19-.93 2.27 2.27 0 1 1 4.44-.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M549.16 167.81a2.35 2.35 0 0 0-1.35 1.47 2.42 2.42 0 0 0 1.55 3.06 2.58 2.58 0 0 0 .95.11 2.39 2.39 0 0 1-1.69.07 2.42 2.42 0 0 1 .54-4.71Z",
    style: {
      fill: "url(#radial-gradient-17)"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M550.11 167.92a2.42 2.42 0 0 1 .2 4.53 2.58 2.58 0 0 1-.95-.11 2.42 2.42 0 0 1-1.55-3.06 2.35 2.35 0 0 1 1.35-1.47 2.24 2.24 0 0 1 .95.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M551.35 181.06a2.38 2.38 0 0 0 1 1.74 2.42 2.42 0 0 0 3.38-.53 2.54 2.54 0 0 0 .4-.87 2.37 2.37 0 0 1-.46 1.63 2.42 2.42 0 0 1-4.31-2Z",
    style: {
      fill: "url(#radial-gradient-18)"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M551.75 180.19a2.42 2.42 0 0 1 4.37 1.21 2.54 2.54 0 0 1-.4.87 2.42 2.42 0 0 1-3.38.53 2.38 2.38 0 0 1-1-1.74 2.29 2.29 0 0 1 .41-.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M564.63 183.07a2.36 2.36 0 0 0 2-.4 2.41 2.41 0 0 0 .54-3.38 2.28 2.28 0 0 0-.7-.65 2.39 2.39 0 0 1 1.41.94 2.42 2.42 0 0 1-3.21 3.49Z",
    style: {
      fill: "url(#radial-gradient-19)"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M563.93 182.42a2.42 2.42 0 0 1 2.5-3.78 2.28 2.28 0 0 1 .7.65 2.41 2.41 0 0 1-.54 3.38 2.36 2.36 0 0 1-2 .4 2.16 2.16 0 0 1-.66-.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M570.65 171.06a2.41 2.41 0 0 0-2.82-3.54 2.45 2.45 0 0 0-.84.46 2.42 2.42 0 1 1 3.66 3.08Z",
    style: {
      fill: "url(#radial-gradient-20)"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M569.81 171.53A2.42 2.42 0 0 1 567 168a2.45 2.45 0 0 1 .84-.46 2.41 2.41 0 0 1 2.82 3.54 2.31 2.31 0 0 1-.85.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#radial-gradient-21)"
    },
    d: "M208.96 116.31h7.4v2.51h-7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.69 115.67a41 41 0 0 1 17.2-.46s-9.8.47-11.9.46-5.3 0-5.3 0Z",
    style: {
      fill: "url(#linear-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.35 94.62a1.5 1.5 0 0 1 .8-2.12c1.54-.6 5.39-1.32 6-1.62s.67-2.25 4.75-2.63c3.55-.32 6.5-.24 8.56.49a5.26 5.26 0 0 0 2.16.25c1.88-.17 5.27-.38 6.29.1 1.44.67 2.74 2.71 1.39 4.25s-5.17 2.24-6.59 2.24a12.93 12.93 0 0 0-4.46 1.42c-.95.44-7.05 1.72-9.76.51a15.72 15.72 0 0 0-5.89-1.34 4.39 4.39 0 0 1-3.25-1.55Z",
    style: {
      fill: "url(#radial-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.07 91.78a2.37 2.37 0 0 1-.28 1.11v.06a2.7 2.7 0 0 1-.27.39l-.14.15-.07.06a4.25 4.25 0 0 1-.83.54 2.92 2.92 0 0 1-.95.2l-5.2.17-13.86.46-5.8.2a1.55 1.55 0 0 1-1.49-.92 1.84 1.84 0 0 1-.1-.42.49.49 0 0 1 0-.12 1.5 1.5 0 0 1 1.35-1.45l24.7-2.94a2.61 2.61 0 0 1 3 2.3 1.49 1.49 0 0 1-.06.21Z",
    style: {
      fill: "url(#linear-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.27 93.55a2.26 2.26 0 0 1-.82.54 3.64 3.64 0 0 0 .82-.54Z",
    style: {
      fill: "url(#linear-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.51 94.29a2.92 2.92 0 0 0 .94-.2 11.13 11.13 0 0 1-5.09 1 1.56 1.56 0 0 1-1.06-.66Z",
    style: {
      fill: "url(#linear-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.76 93a1.44 1.44 0 0 1-.27.39 2.7 2.7 0 0 0 .27-.39Z",
    style: {
      fill: "url(#linear-gradient-58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.44 94.92c-.35.35-.85.79-1 .79a28.6 28.6 0 0 1-4.23-.1c-1.93-.24-2-1.41-2-1.41a1.55 1.55 0 0 0 1.49.92Z",
    style: {
      fill: "url(#linear-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.84 89.27a1.51 1.51 0 0 1 .81-2.13c1.53-.6 5.38-1.32 5.94-1.62s.67-2.25 4.76-2.62c3.54-.33 6.49-.25 8.55.48a5.26 5.26 0 0 0 2.16.25c1.88-.16 5.28-.38 6.29.1 1.44.67 2.74 2.71 1.39 4.25s-5.17 2.25-6.59 2.25a12.6 12.6 0 0 0-4.4 1.44c-1 .44-7.06 1.71-9.77.51a15.56 15.56 0 0 0-5.89-1.35 4.41 4.41 0 0 1-3.25-1.56Z",
    style: {
      fill: "url(#radial-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.56 86.42a2.37 2.37 0 0 1-.28 1.11v.06a2.7 2.7 0 0 1-.28.41l-.14.15a.46.46 0 0 0-.07.07 4.22 4.22 0 0 1-.83.53 2.68 2.68 0 0 1-.94.2l-5.21.17-13.86.47-5.8.19a1.53 1.53 0 0 1-1.48-.92 1.44 1.44 0 0 1-.11-.42.49.49 0 0 1 0-.12 1.5 1.5 0 0 1 1.35-1.45l24.7-2.94a2.62 2.62 0 0 1 3 2.3c-.06.06-.05.12-.05.19Z",
    style: {
      fill: "url(#linear-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.77 88.2a2.5 2.5 0 0 1-.83.53 3.94 3.94 0 0 0 .83-.53Z",
    style: {
      fill: "url(#linear-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 88.93a2.68 2.68 0 0 0 .94-.2 11.13 11.13 0 0 1-5.09 1 1.56 1.56 0 0 1-1.06-.66Z",
    style: {
      fill: "url(#linear-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.25 87.59a1.44 1.44 0 0 1-.25.41 2.7 2.7 0 0 0 .25-.41Z",
    style: {
      fill: "url(#linear-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.93 89.57c-.35.34-.85.79-1 .79a29.2 29.2 0 0 1-4.23-.11c-1.92-.23-2-1.41-2-1.41a1.53 1.53 0 0 0 1.48.92Z",
    style: {
      fill: "url(#linear-gradient-64)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMobile);
export default __webpack_public_path__ + "static/media/header-mobile.d56df81625eced3c8f9d5e95981fb85d.svg";
export { ForwardRef as ReactComponent };